import React from "react";
import { Link } from "react-router-dom";
import "./css/page-header.css";

const PageHeader = ({ title, bgImage, breadcrumbs }) => {
  return (
    <section 
      className="page-header-section" 
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="page-header-overlay"></div>
      
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="page-header-content">
              
              <h1 className="page-header-title">{title}</h1>
              
              <nav className="breadcrumb-nav">
                {breadcrumbs.map((item, index) => {
                  const isLast = index === breadcrumbs.length - 1;

                  return (
                    <div key={index} className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                      
                      {/* If not the first item, show separator before it */}
                      {index !== 0 && (
                        <i className="fa-solid fa-angle-left breadcrumb-separator"></i>
                      )}

                      {isLast ? (
                        // If it's the last item, just render text (Current Page)
                        <span>{item.label}</span>
                      ) : (
                        // If it's not the last item, render a Link
                        <Link to={item.path}>{item.label}</Link>
                      )}
                      
                    </div>
                  );
                })}
              </nav>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;